<template>
  <!-- class="lg:flex flex-1" -->
  <div>
    <TNavComponent/>
    <toTopComponent/>
    <contentsMainPage />
    <FooterComponent/>
  </div>
</template>

<script>
import TNavComponent from "@/components/TNavComponent.vue"
import toTopComponent from "@/components/toTopComponent.vue"
import contentsMainPage from "@/pages/contentsMall/contentsMainPage.vue"
import FooterComponent from "@/components/FooterComponent.vue";

export default {
  name: "contentsMain",
  components: {contentsMainPage, TNavComponent, toTopComponent, FooterComponent}
}
</script>
